import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { addCategory } from "../../redux/actions/categoryActions";

export default function AddCategory({ onCloseModal }) {
  const dispatch = useDispatch();

  const { loading = false, error = "", status = "idle" } = useSelector(
    (state) => state.category || {}
  );

  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");

  const handleClose = () => {
    setCategoryName("");
    setCategoryDescription("");
    onCloseModal(); // Close modal after clearing form
  };

  const handleAddCategory = () => {
    if (!categoryName) {
      toast.error("Category Name is required.");
      return;
    }
    if (!categoryDescription) {
      toast.error("Category Description is required.");
      return;
    }

    dispatch(
      addCategory({ name: categoryName, description: categoryDescription })
    );
  };

  // Listen for category add success or failure
  useEffect(() => {
    if (status === "succeeded") {
      toast.success("Category added successfully!");
      handleClose();
    }
    if (status === "failed" && error) {
      toast.error(`Failed to add category: ${error}`);
    }
  }, [status, error]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="relative w-11/12 md:w-1/2 lg:w-1/3 mx-auto bg-white rounded-lg shadow-lg">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-2xl font-semibold text-gray-800">Add Category</h3>
          <button
            className="p-1 text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={handleClose}
            aria-label="Close modal"
          >
            <span className="text-3xl">×</span>
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6 overflow-y-auto" style={{ maxHeight: "60vh" }}>
          <div className="space-y-4">
            <div>
              <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                id="categoryName"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                type="text"
                placeholder="Enter Category Name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="categoryDescription" className="block text-sm font-medium text-gray-700">
                Description
              </label>
              <input
                id="categoryDescription"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                type="text"
                placeholder="Enter Category Description"
                value={categoryDescription}
                onChange={(e) => setCategoryDescription(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="flex items-center justify-end p-6 border-t border-gray-200">
          <button
            className="mr-2 px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 focus:outline-none"
            type="button"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none disabled:opacity-50"
            type="button"
            onClick={handleAddCategory}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Category"}
          </button>
        </div>
      </div>
    </div>
  );
}